import { useIntl } from "react-intl"
import { filterInfo, getGenderFilter } from "components/Shared/Hooks/filterInfo"
import { ID_INTL_FILTER } from "components/Transactional/Performance/components/SummaryTable/SummaryTable.consts"
import React from "react"

const SPENDING_RATE = "spending_rate"
const WEIGHTED_PENETRATION = "weighted_penetration"
const CLOSING_RATE = "closing_rate"

const firstColumnNames: Record<string, string> = {
	[SPENDING_RATE]:
		"phronesis.transactional.application.commercial.benchmark.vsm.summary.spending_rate.row_1",
	[WEIGHTED_PENETRATION]:
		"phronesis.transactional.application.commercial.benchmark.vsm.summary.side_header.row_1",
	[CLOSING_RATE]:
		"phronesis.transactional.application.commercial.benchmark.vsm.summary.side_header.row_1",
}

const secondColumnNames: Record<string, string> = {
	[SPENDING_RATE]:
		"phronesis.transactional.application.commercial.benchmark.vsm.summary.spending_rate.row_2",
}

const needChangeInText = (id: string | undefined) => {
	return id && secondColumnNames[id]
}

export const columnTranslate = (id: string) => {
	const intl = useIntl()
	const filter = filterInfo()
	const isPlural = filter.isMultiSelect
	const isPluralize = filter.geTypeSelect
	const levelName = intl.formatMessage(
		{
			id: ID_INTL_FILTER + filter.currentLevel,
		},
		{ isPluralize }
	)
	const filterNameOrDetailValue = isPlural
		? levelName
		: filter?.getSelectValueByIndex(0)?.toLowerCase()
	return intl.formatMessage(
		{ id: firstColumnNames[id] },
		{ filter: filterNameOrDetailValue }
	)
}

export const useGetLevelTranslate = (id: string, identifierName?: string) => {
	const intl = useIntl()
	const idIntl = needChangeInText(identifierName)
	const filter = filterInfo()
	const isPlural = filter.isMultiSelect
	const isPluralize = filter.geTypeSelect
	const isGender = getGenderFilter(filter.currentLevel)
	const levelName = intl.formatMessage(
		{
			id: ID_INTL_FILTER + filter.currentLevel,
		},
		{ isPluralize }
	)

	const filterNameOrDetailValue = isPlural
		? levelName
		: filter?.getSelectValueByIndex(0)?.toLowerCase()

	if (idIntl) {
		return intl.formatMessage(
			{ id: idIntl },
			{ filter: filterNameOrDetailValue }
		)
	}
	return intl.formatMessage(
		{
			id: id,
		},
		{
			isPluralize,
			filter: filterNameOrDetailValue,
			isGender,
			b: (text: string) => <b>{text}</b>,
		}
	)
}
